import TableHeader from "../../../../components/table/TableHeader";
import { useState } from "react";
import { useGetStockHistory } from "../../api/product/stock/resolver";
import TableFC, {
  TableFCBodyProps,
  TableHeadProps,
} from "../../../../components/table/Table";
import { Box, Link } from "@mui/material";

export default function StockHistory({ productId }: { productId: string }) {
  const [keyword, setKeyword] = useState("");
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const { data: dataRawStockHistory, isLoading: isFetching } =
    useGetStockHistory({
      product_id: productId,
      keyword,
      page,
      perPage,
    });
  const dataStockHistory = dataRawStockHistory?.data.data.data;
  const header: TableHeadProps[] = [
    { title: "No" },
    { title: "ID Invoice" },
    { title: "Harga" },
    { title: "Jumlah" },
    { title: "Catatan" },
    { title: "Tanggal" },
  ];
  const bodyTable: TableFCBodyProps[] = [
    {
      key: "",
      component: (item) => {
        const isPurchasingInvoice = item.invoice !== null;
        return (
          <Box>
            {isPurchasingInvoice ? (
              <Box>{item?.invoice?.invoice_number}</Box>
            ) : (
              // <Link href={`/invoice/creation/${item?.invoice_id}`}>
              //   {item?.invoice?.invoice_number}
              // </Link>
              item?.purchase_invoice_id || "-"
            )}
          </Box>
        );
      },
    },
    { key: "price" },
    { key: "quantity" },
    { key: "description" },
    { key: "created_at", isDate: true },
  ];

  return (
    <Box>
      <TableHeader
        filterLabel="Search History Barang"
        searchBar
        onSearch={(e) => setKeyword(e)}
      />
      <TableFC
        loading={isFetching}
        data={dataStockHistory}
        body={bodyTable}
        showIndex
        totalRows={dataRawStockHistory?.data.data?.total}
        perColumns={perPage}
        onPerPageChange={(e) => setPerPage(e)}
        head={header}
        onPageChange={(e) => setPage(e)}
      />
    </Box>
  );
}
